import Window from 'window-or-global'
import EventBus from '@/services/bus'
import * as types from './mutation-types.js'
import { getDeepProperty } from '@/helpers/deepObject.js'

// PODCAST_DOWNLOADS
export const setPodcastDownloadsError = ({ podcastId, error }) => {
  Window.console.error(error)
  EventBus.$emit('SHOW_ERROR_MESSAGE', {
    key: `analytics/${types.SET_PODCAST_DOWNLOADS_ERROR}`,
    error: new Error(`API error: could not retrieve analytics downloads for podcast ${podcastId}`),
    type: getDeepProperty(error, 'response.data.error')
  })
}
// EPISODE_DOWNLOADS
export const setEpisodeDownloadsError = ({ episodeId, error }) => {
  Window.console.error(error)
  EventBus.$emit('SHOW_ERROR_MESSAGE', {
    key: `analytics/${types.SET_EPISODE_DOWNLOADS_ERROR}`,
    error: new Error(`API error: could not retrieve analytics downloads for episode ${episodeId}`),
    type: getDeepProperty(error, 'response.data.error')
  })
}
